module.exports = __webpack_public_path__ + "img/you.ea10e9c5.png";